import { useRef } from 'react';

import { useSearch } from './contexts/SearchContext';
import { SearchFlyout } from './SearchFlyout';
import { SearchInput } from './SearchInput';

const Search = () => {
    const flyoutRef = useRef<HTMLDivElement>(null);
    const { flyoutOpen, handleClose } = useSearch();

    return (
        <>
            <SearchInput>
                <SearchFlyout ref={flyoutRef} />
            </SearchInput>
            {flyoutOpen && (
                <div
                    data-testid="search-overlay"
                    className="fixed top-0 left-0 right-0 bottom-0 z-50"
                    onClick={handleClose}
                ></div>
            )}
        </>
    );
};

export default Search;
